var render = function render(){var _vm=this,_c=_vm._self._c;return (_vm.isShow)?_c('div',{staticClass:"now",style:(_vm.styleString)}):_vm._e()
}
var staticRenderFns = []

export { render, staticRenderFns }